<template>
  <div class="content_box">
    <div v-if="!isLogin">
      <div class="head_box">
        <img src="../assets/index.png" class="index_img" />
        <div class="head_notice">智云电力</div>
      </div>
      <div class="login_box" @click="pwdLogin">
        <div class="user_image">
          <img src="../assets/user.png" alt />
        </div>
        <div class="login_title">点击登录</div>
      </div>
    </div>
    <div v-else @click="bindAccount">
      <div class="head2_box">
        <div class="head_notice">智云电力</div>
        <div class="bind_box">
          <div class="bind_btn">
            <img src="../assets/user2.png" style="position: absolute; bottom: 10px; left: 25px" />
          </div>
          <div class="nobind2" v-if="isbindCount">
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: center;
              "
              @click="toggle($event)"
            >
              <div class="consName">{{ activeConsInfo.consName }}({{ activeConsInfo.consNo }})</div>
              <img src="../assets/change.png" alt />
            </div>
            <span>{{ activeConsInfo.elecAddr }}</span>
            <collapse-transition>
              <div class="collapse-wrap" v-show="isActive">
                <div
                  v-for="(item, index) in actions"
                  class="content1"
                  :class="{ 'content-active': index == selectedIndex }"
                  @click="selectCount(item.id, index)"
                >
                  <div class="content_text">{{ item.text }}</div>
                  <img
                    v-if="index == selectedIndex"
                    src="@/assets/selected.png"
                    class="selected_img"
                  />
                </div>
              </div>
            </collapse-transition>
          </div>
          <div class="nobind" v-else>
            未绑定用户
            <img src="../assets/change.png" alt />
          </div>
        </div>
        <div class="power_box">
          <div class="power_info">
            <div class="head_notice">智云电力</div>
            <div
              style="
                margin-top: 30px;
                display: flex;
                align-items: center;
                justify-content: space-around;
              "
            >
              <div>
                <div
                  style="
                    display: flex;
                    align-items: center;
                    color: #fff;
                    font-size: 0.26rem;
                  "
                >
                  <img src="../assets/power.png" style="width:16.8px;height:16.8px" />
                  <div style="margin-left: 5px;line-height:20px">
                    电量
                    <span style="font-size: 12px">（度）</span>
                  </div>
                </div>
                <div
                  style="color: #fff; font-size: 0.36rem"
                >{{ activeConsInfo.usedNumber?activeConsInfo.usedNumber:'---' }}</div>
              </div>
              <div>
                <div
                  style="
                    color: #fff;
                    display: flex;
                    font-size: 0.26rem;
                    align-items: center;
                  "
                >
                  <img src="../assets/powerFee.png" style="width:16.8px;height:16.8px" />
                  <div style="margin-left: 5px;line-height:20px">
                    电费
                    <span style="font-size: 12px">（元）</span>
                  </div>
                </div>
                <div
                  style="color: #fff; font-size: 0.36rem"
                >{{ activeConsInfo.feesAmount?activeConsInfo.feesAmount:"---" }}</div>
              </div>
            </div>
          </div>
          <div class="balance_box" @click="toBill">
            <div
              style="color: #fff; padding-top: 20px; font-size: 0.36rem"
            >{{ activeConsInfo.balance?activeConsInfo.balance:'---' }}</div>
            <div style="margin-left: 5px; font-size: 0.26rem">
              可用余额
              <span style="font-size: 12px">（元）</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="menu_box">
      <div class="menu_item" @click="toRecharge">
        <div class="menuImg_box" style="background: #63c5fd">
          <img src="../assets/entry1.png" class="entry" />
        </div>
        <div class="menu_info">
          <div class="menu_h1">充值缴费</div>
          <div class="menu_h2">指尖缴电费</div>
        </div>
      </div>
      <div class="menu_item" @click="actingCapture">
        <div class="menu_info">
          <div class="menu_h1">代缴电费</div>
          <div class="menu_h2">无需登录缴费</div>
        </div>
        <div class="menuImg_box" style="background: #3dccb1">
          <img src="../assets/entry7.png" class="entry" />
        </div>
      </div>
      <div class="menu_item" @click="toHistory">
        <div class="menuImg_box" style="background: #ffa101">
          <img src="../assets/entry3.png" class="entry" />
        </div>
        <div class="menu_info">
          <div class="menu_h1">最新账单</div>
          <div class="menu_h2">查看最新账单</div>
        </div>
      </div>
      <div class="menu_item" @click="toBill">
        <div class="menu_info">
          <div class="menu_h1">缴费记录</div>
          <div class="menu_h2">查询缴费记录</div>
        </div>
        <div class="menuImg_box" style="background: #f86f0a">
          <img src="../assets/entry6.png" class="entry" />
        </div>
      </div>
    </div>
    <div class="userInfo" v-if="isLogin && activeConsInfo.tqlxr && activeConsInfo.tqlxdh">
      <div>联系人：{{activeConsInfo.tqlxr}}</div>
      <div>联系方式：{{activeConsInfo.tqlxdh}}</div>
    </div>
    <!-- <van-dialog v-model="show" :show-confirm-button="false" :close-on-click-overlay="true">
      <div class="modal_head">您还未登录</div>
      <div class="wx_login" @click="wxLogin">微信授权登录</div>
      <div class="pwd_login" @click="pwdLogin">账号密码登录</div>
    </van-dialog>-->
  </div>
</template>
<script>
import collapseTransition from "@/libs/collapse.js";
import {
  login,
  queryBindConsNoList,
  queryBindFeeCons,
  rememberCons,
  checkRegisit
} from "@/api/user.js";
import { setToken, getToken } from "../libs/util.js";
import Vue from "vue";
import { Dialog, Notify, Popover,Toast } from "vant";
Vue.use(Dialog);
Vue.use(Notify);
Vue.use(Popover);
export default {
  components: {
    collapseTransition
  },
  data() {
    return {
      appId: config.appId,
      url: config.url,
      show: false,
      isActive: false,
      isLogin: false,
      isbindCount: false,
      activeConsInfo: {
        tqlxr: "",
        tqlxdh: ""
      },
      showPopover: false,
      // 通过 actions 属性来定义菜单选项
      actions: [],
      selectedIndex: 0
    };
  },
  created() {
    console.log(config);
    if (!getToken()) {
      if (this.$route.query.code) {
        login({ code: this.$route.query.code }).then(res => {
          if (res.data.status == 1004) {
            this.$router.push({
              path: `/tcmr/bindOpenId`
            });
            // localStorage.setItem("openId", res.data.object);
            localStorage.setExpire("openId", res.data.object, 86400000);
            this.isLogin = false;
          } else if (res.data.status == 200) {
            this.isLogin = true;
            setToken(res.data.object);
            this.queryBindConsNoList();
          } else {
            this.isLogin = false;
            Notify(res.data.msg);
          }
        });
      }
    } else {
      this.isLogin = true;
      this.queryBindConsNoList();
    }
  },
  mounted() {
    // if (!window.localStorage.getItem("openId")) {
    //   // 如果缓存localStorage中没有微信openId，则需用code去后台获取
    //   this.getCode();
    // } else {
    //   // 别的业务逻辑
    // }
  },
  methods: {
    getUrlCode() {
      // 截取url中的code方法
      var url = location.search;
      this.winUrl = url;
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
        }
      }
      return theRequest;
    },

    wxLogin() {
      this.show = false;
      location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${
        this.appId
      }&redirect_uri=${encodeURIComponent(this.url)}${encodeURIComponent(
        "tcmr/home"
      )}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`;
    },
    pwdLogin() {
      this.$router.push({
        path: "/tcmr/login"
      });
      // checkRegisit(localStorage.getExpire("openId")).then(res => {
      //   if (res.data.status == 1105) {
      //     this.$router.push({
      //       path: "/tcmr/bindOpenId"
      //     });
      //   } else if (res.data.status == 200) {
      //     this.$router.push({
      //       path: "/tcmr/login"
      //     });
      //   } else {
      //     Notify(res.data.msg);
      //   }
      // });
    },
    actingCapture() {
      this.$router.push({
        path: `/tcmr/actingCapture`
      });
    },
    selectCount(consId, index) {
      this.isActive = false;
      this.selectedIndex = index;
      this.queryBindFeeCons(consId);
      this.rememberCons(consId);
    },
    toggle(el) {
      console.log(el);
      this.isActive = !this.isActive;
      // if (this.isActive) {
      //   el.target.innerHTML = "收缩";
      // } else {
      //   el.target.innerHTML = "打开";
      // }
    },
    toBill() {
      if (this.isbindCount) {
        this.$router.push({
          path: `/tcmr/paymentRecords?consId=${this.activeConsInfo.consId}`
        });
      } else {
        this.$router.push({
          path: `/tcmr/bindAccount`
        });
      }
    },
    toRecharge() {
      if (this.isbindCount) {
        this.$router.push({
          path: `/tcmr/WxRecharge?state=${this.activeConsInfo.consId}`
        });

      //   location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${
      //     this.appId
      //   }&redirect_uri=${encodeURIComponent(this.url)}${encodeURIComponent(
      //     "tcmr/WxRecharge"
      //   )}&response_type=code&scope=snsapi_base&state=${
      //     this.activeConsInfo.consId
      //   }#wechat_redirect`;
      } else {
        this.$router.push({
          path: `/tcmr/bindAccount`
        });
      }
    },
    toHistory() {
      if (this.isbindCount) {
        this.$router.push({
          path: `/tcmr/electricityHistory?consId=${
            this.activeConsInfo.consId ? this.activeConsInfo.consId : ""
          }`
        });
      } else {
        this.$router.push({
          path: `/tcmr/bindAccount`
        });
      }
    },
    queryBindConsNoList() {
      this.actions = [];
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0
      });

      queryBindConsNoList().then(res => {
        Toast.clear();
        if (res.data.status == 200) {
          res.data.object.forEach(element => {
            this.actions.push({
              id: element.consId,
              consNo: element.consNo,
              text: `${element.consName}(${element.consNo})`
            });
          });

          if (res.data.object && res.data.object.length > 0) {
            this.queryBindFeeCons(res.data.object[0].consId);
            this.isbindCount = true;
          } else {
            this.isbindCount = false;
          }
        }
      });
    },
    //查询当前已绑定的户号
    queryBindFeeCons(consId) {
      queryBindFeeCons(consId).then(res => {
        if (res.data.status == 200) {
          this.activeConsInfo = res.data.object;
        } else {
          Notify({ type: "danger", message: res.data.msg });
        }
      });
    },
    rememberCons(consId) {
      rememberCons(consId).then(res => {
        // 成功或失败都不用做任何处理
      });
    },
    bindAccount() {
      if (!this.isbindCount) {
        this.$router.push({
          path: "/tcmr/bindAccount"
        });
      }
    }
  }
};
</script>
<style  scoped>
.userInfo {
  width: 100%;
  bottom: 50px;
  display: flex;
  height: 0.5rem;
  color: #ffffff;
  font-size: 0.2rem;
  position: absolute;
  align-items: center;
  line-height: 0.5rem;
  background: #66e4cf;
  justify-content: space-evenly;
}
.avatar_img {
  width: 1rem;
  height: 1rem;
}
.content_text {
  width: 240px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.selected_img {
  height: 0.22rem;
  margin-left: 0.2rem;
}
.collapse-wrap {
  width: 5rem;
  max-height: 5rem;
  margin: 0 auto;
  overflow: scroll;
  border: 1px solid #ddd;
  background-color: #fff;
}
.collapse_btn {
  width: 100px;
  height: 50px;
  border: 1px solid;
  border-radius: 25px;
  margin-left: 150px;
  text-align: center;
  line-height: 50px;
  font-size: 22px;
}
.content1 {
  display: flex;
  color: #666666;
  text-align: center;
  font-size: 0.22rem;
  text-align: left;
  align-items: center;
  padding: 0.1rem 0.1rem;
}

.content-active {
  background-color: #e7f8f5;
  display: flex;
  color: #666666;
  font-size: 0.22rem;
  align-items: center;
  padding: 0.1rem 0.1rem;
}

.changeUserBox {
  z-index: 2;
  position: absolute;
  top: 4.8rem;
  left: 50%;
  box-shadow: 0rem 0rem 0.3rem rgba(0, 0, 0, 0.2);
  margin-left: -2.5rem;
  width: 5rem;
}
.changeUserBox ul {
  border: 1px solid #ddd;
  background-color: #fff;
  margin: 0;
  height: 5rem;
  overflow-y: scroll;
}
.changeUserBox ul li:last-child {
  border: none;
}

.index_img {
  top: 0px;
  left: 0px;
  width: 100%;
  z-index: -1;
  height: 240px;
  position: absolute;
}
.entry {
  width: 49.5px;
  height: 49.5px;
}
.consName {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.power_box {
  width: 100%;
  top: 0;
  position: absolute;
}
.power_info {
  height: 100px;
  background: #66e4cf;
}
.balance_box {
  width: 100%;
  height: 80px;
  color: #fff;
  /* margin: 50px; */
  background: #66e4cf;
  border-radius: 50% / 0 0 100% 100%;
}
.head2_box {
  height: 260px;
  position: relative;
  background: #1bbc9b;
}
.menu_box {
  display: flex;
  flex-wrap: wrap;
}
.menu_info {
  width: 90px;
  text-align: left;
  margin-left: 8px;
}
.menu_h1 {
  font-size: 0.25rem;
}
.menu_h2 {
  color: #b1b1b1;
  font-size: 12px;
  margin-top: 0.1rem;
}
.menu_item {
  width: 49%;
  display: flex;
  margin-top: 20px;
  align-items: center;
  /* padding-bottom: 20px; */
  justify-content: center;
}
.menuImg_box {
  width: 49.5px;
  display: flex;
  height: 49.5px;
  border-radius: 50%;
}

.bind_box {
  padding-top: 45px;
}
.login_box {
  margin-top: -30px;
}
.login_title {
  font-size: 16px;
}
.user_image {
  width: 46px;
  background: #ececf1;
  height: 46px;
  align-items: center;
  justify-content: center;
  display: flex;
  margin: 0 auto;
  border-radius: 50%;
  border: 1px solid #ececf1;
}
.modal_note {
  font-size: 14px;
  margin-top: 30px;
  color: #b1b1b1;
}
.btn_title2 {
  width: 135px;
  text-align: left;
}
.modal_content {
  padding: 20px 30px 30px 30px;
}

.phone_btn {
  padding: 2px 0;
  display: flex;
  margin-top: 20px;
  border-radius: 10px;
  background: #3d8bf8;
  color: #ffffff;
  justify-content: center;
  align-items: center;
}
.wechat_btn {
  padding: 2px 0;
  display: flex;
  margin-top: 20px;
  border-radius: 10px;
  background: #34ca5f;
  color: #ffffff;
  justify-content: center;
  align-items: center;
}

.head_box {
  height: 240px;
}
.head_notice {
  padding-top: 20px;
  color: #ffffff;
  font-size: 16px;
}
.nobind {
  display: flex;
  font-size: 12px;
  margin-top: 5px;
  color: #ffffff;
  align-items: center;
  justify-content: center;
}
.nobind2 {
  font-size: 12px;
  margin-top: 5px;
  color: #ffffff;
}
.bind_btn {
  width: 80px;
  height: 80px;
  margin: 0 auto;
  margin-top: 50px;
  line-height: 80px;
  position: relative;
  border-radius: 50%;
  background: #e5f1fd;
}
</style>